module.exports = __webpack_public_path__ + "static/img/07_tssi.5481ec9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/07_tssi.jpg
// module id = giv4
// module chunks = 0